var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// <!--诉讼待分配-->
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
var OutsourceLawsuitBackService = /** @class */ (function () {
    function OutsourceLawsuitBackService() {
    }
    /**
     * 委外管理-委外诉讼回收案件-列表
     */
    OutsourceLawsuitBackService.prototype.searchLawsuitRecoveryList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourceLawsuitBackManageController.searchLawsuitRecoveryList,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 委外管理-委外诉讼回收案件-移入诉讼待分配
     */
    OutsourceLawsuitBackService.prototype.moveLawsuitWait = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitBackManageController.moveLawsuitWait,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceLawsuitBackService.prototype, "netService", void 0);
    return OutsourceLawsuitBackService;
}());
export { OutsourceLawsuitBackService };
